import { Label as LabelPrimitive } from 'radix-ui';
import * as React from 'react';

import { cn } from './utils/cn';

/**
 * Accessible label primitive that pairs with form controls via `htmlFor`.
 *
 * @example
 * <Label htmlFor="email">Email address</Label>
 */
const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & {
    size?: 'default' | 'sm';
  }
>(({ className, size = 'default', ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    data-slot="label"
    className={cn(
      'flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
      size === 'sm' &&
        'text-2xs leading-[1.42] font-bold tracking-[0.55px] text-text-tertiary uppercase',
      className,
    )}
    {...props}
  />
));
Label.displayName = 'Label';

export { Label };
